import React from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Alert, Box, CircularProgress, Container } from '@mui/material';

import { useGetTourOffer, useGetTourOfferForTour } from '~/hooks/apis/tours/useTourOffers';

import NativeTourEditor from '../NativeTour/NativeTourEditor';
import { isNativeTourModelEnabled } from '../nativeTourModel';

const EDITOR_MAX_WIDTH = 1800;

export default function NativeTourPage() {
  const { tour_id } = useParams<{ tour_id: string }>();
  const legacyTourId = tour_id?.replace(/^tour-/, '');
  const isEnabled = isNativeTourModelEnabled();
  const summary = useGetTourOfferForTour(isEnabled ? legacyTourId : undefined);
  const offer = useGetTourOffer(summary.data?.id);

  const body = () => {
    if (!isEnabled) {
      return <Alert severity="info">The new tour model isn't available here.</Alert>;
    }
    if (summary.isLoading || offer.isLoading) {
      return (
        <Box p={4} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      );
    }
    if (summary.error || offer.error) {
      return <Alert severity="error">{(summary.error ?? offer.error).message}</Alert>;
    }
    if (!summary.data || !offer.data) {
      return (
        <Alert severity="info">
          This tour isn't in the new tour model yet. Sync it with native-sync.sh, then come back.
        </Alert>
      );
    }
    return <NativeTourEditor offer={offer.data} legacyTourId={legacyTourId} />;
  };

  return (
    <>
      <Helmet>
        <title>Tours | New tour model</title>
      </Helmet>
      {/* Wider than xl for the side nav and paired cards, capped so lines stay easy to scan. */}
      <Container maxWidth={false} sx={{ maxWidth: EDITOR_MAX_WIDTH, px: { xs: 2, md: 4 } }}>
        {body()}
      </Container>
    </>
  );
}
